// Seis hojas pixel art distintas (mismo estilo y paleta "fin de verano" que las
// ramas de Experience.vue), cada una con su versión de noche. Las usan las hojas
// que caen (PixelLeaves.vue) y las amontonadas en el piso del footer.
export const LEAF_SPRITES = [1, 2, 3, 4, 5, 6].map((n) => ({
    day: require(`@/assets/leaves/leaf-${n}.svg`),
    night: require(`@/assets/leaves/leaf-${n}-night.svg`),
}))
